// The row of five step names at the top of the wizard: which one is on, which
// are done. Drawn by the shell on every step, so it has its own file.

import { Icon } from '../../components/ui'
import { IMPORT_STEPS } from '../../lib/importWords'

export function Stepper({ step }: { step: number }) {
  return (
    <div className="stepper" role="group" aria-label="Steps" style={{ flexWrap: 'wrap', rowGap: 8 }}>
      {IMPORT_STEPS.map((t, i) => (
        <span key={t} style={{ display: 'contents' }}>
          {i > 0 && <span className="bar" style={{ flex: '0 1 32px', minWidth: 8 }} aria-hidden="true" />}
          <span
            className={'st' + (step === i + 1 ? ' on' : step > i + 1 ? ' done' : '')}
            aria-current={step === i + 1 ? 'step' : undefined}
          >
            <span className="n">{step > i + 1 ? <Icon name="check" size={12} /> : i + 1}</span> {t}
            {step > i + 1 && <span className="vh"> (done)</span>}
          </span>
        </span>
      ))}
    </div>
  )
}
